// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3wNbW","requiredAsterisk":"Info_requiredAsterisk__2J5J4"};